import { FC } from 'react';
import dayjs from 'dayjs';
import { ModalComponent } from 'components/Modal';
import { ENV_CONFIG } from 'config/environment';
import { RecipientAdminRow } from 'services/recipientAdminsApi';
import { getPositionCategoryLabel, getStatusLabel, isTermsAccepted } from './helpers';

interface Props {
  admin: RecipientAdminRow | null;
  onClose: () => void;
}

export const AdminDetailModal: FC<Props> = ({ admin, onClose }) => {
  return (
    <ModalComponent isOpen={!!admin} closeModal={onClose}>
      {admin && (
        <div className="grid-column">
          <span className="oath-eyebrow inkBlue">Admin details</span>
          <span className="oath-h4 inkBlue">
            {admin.first_name} {admin.last_name}
            {admin.is_primary_contact && ' · Primary Contact'}
          </span>
          <span className="oath-body inkBlue">Email: {admin.email}</span>
          <span className="oath-body inkBlue">
            Position: {getPositionCategoryLabel(admin.position_category)}
          </span>
          <span className="oath-body inkBlue">Status: {getStatusLabel(admin)}</span>
          <span className="oath-body inkBlue">
            Terms accepted: {isTermsAccepted(admin) ? 'Yes' : 'No'}
          </span>
          <span className="oath-body inkBlue">
            Added: {dayjs(admin.created_at).format('MMM D, YYYY')}
          </span>
          <span className="oath-bodysmall gray">
            To correct any of these details, email{' '}
            <a href={`mailto:${ENV_CONFIG().RECIPIENTS_SUPPORT_EMAIL}`}>
              {ENV_CONFIG().RECIPIENTS_SUPPORT_EMAIL}
            </a>
            .
          </span>
        </div>
      )}
    </ModalComponent>
  );
};
